module.exports = __webpack_public_path__ + "img/HNYT087_19.9169b09a.gif";